import script from "./HeadCont2.vue?vue&type=script&setup=true&lang=js"
export * from "./HeadCont2.vue?vue&type=script&setup=true&lang=js"

import "./HeadCont2.vue?vue&type=style&index=0&id=7929992c&lang=scss&scoped=true"
import "./HeadCont2.vue?vue&type=style&index=1&id=7929992c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7929992c"]])

export default __exports__